import React from 'react';

import {PanelGroupingContextProvider} from '../PanelRunsLinePlot/RunsLinePlotContext/usePanelGroupingSettings';
import {useLinePlotSettingsWithDefaults} from '../WorkspaceDrawer/Settings/runLinePlots/utils/getLinePlotSettings';
import PanelScalarChart, {PanelScalarChartProps} from './Component';

const Wrapper = (props: PanelScalarChartProps) => {
  const {useRunsTableGroupingInPanels} = useLinePlotSettingsWithDefaults(
    props.config
  );
  return (
    <PanelGroupingContextProvider
      aggregate={props.config.aggregate ?? false}
      aggregateMetrics={props.config.aggregateMetrics ?? false}
      groupAgg={props.config.groupAgg}
      groupArea={props.config.groupArea}
      groupBy={props.config.groupBy ?? ''}
      runSets={props.pageQuery.runSets ?? []}
      useRunsTableGroupingInPanels={useRunsTableGroupingInPanels}>
      <PanelScalarChart {...props} />
    </PanelGroupingContextProvider>
  );
};

export default Wrapper;
